export default __webpack_public_path__ + "static/media/resposta_errada.d48d95cf.mp3";